module.exports = __webpack_public_path__ + "static/img/ys_2.2d46ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/生命科学研究设备及原料/ys_2.png
// module id = S3r/
// module chunks = 1